import { PriceTableDto } from '@tiendanube/common';
import axios from 'App/axios';
import { GetPriceTablesType } from 'domains/Customers/PriceTables/priceTablesService/types';

const getPriceTables: GetPriceTablesType = async () => {
  const { data } = await axios.get<PriceTableDto[]>('/price-tables');
  return data;
};

const priceTablesService: {
  getPriceTables: GetPriceTablesType;
} = {
  getPriceTables,
};

export default priceTablesService;
